import { BaSeCheckbox } from "@base/react";
import { INDICATORS_MAPPING } from "../../../mocks/consts";
import {eventTag} from "../../../services/utils";

const IndicatorsSelectionStep = ({
                                   selectedIndicators,
                                   toggleIndicator,
                                   toggleAll,
                                   eventLabGA,
                                 }) => {
  const allSelected = selectedIndicators.length === INDICATORS_MAPPING.length;

  const handleToggleAll = () => {
    toggleAll(INDICATORS_MAPPING);
  }

  return (
    <div className="indicators-selection-container">
      <BaSeCheckbox
        label="Selecionar todos"
        checked={allSelected}
        onChange={() => handleToggleAll()}
      />
      <div className="indicators-selection-grid">
        {INDICATORS_MAPPING.map((item) => (
          <div key={item.identifier} className="indicators-selection-card">
            <BaSeCheckbox
              checked={selectedIndicators.includes(item.identifier)}
              onChange={() => {
                toggleIndicator(item.identifier)
                eventTag(eventLabGA?.name, "identifier", eventLabGA?.action, `Comparar: ${item?.title}`)
              }}
              shape="square"
            />
            <div className="indicators-selection-card-text">
              <p>{item.title}</p>
              <span>{item.subtitle}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default IndicatorsSelectionStep;
